import PropTypes from "prop-types";
import React from "react";
import { Loader, Message } from "semantic-ui-react";
import Branding from "shared/selectors/branding";

export default class UnitAwarePage extends React.Component {
  static propTypes = {
    i18n: PropTypes.object.isRequired,
    loadUnit: PropTypes.func.isRequired,
    children: PropTypes.object.isRequired,
    isReady: PropTypes.bool.isRequired,
    branding: PropTypes.instanceOf(Branding).isRequired
  };

  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    const { loadUnit, branding } = this.props;

    this.setState({ isLoading: true });
    loadUnit(true, branding.getGlencoeURL())
      .then(() => this.setState({ isLoading: false }))
      .catch(() => this.setState({ isLoading: false }));
  }

  render() {
    const { isLoading } = this.state;
    const { children, isReady, i18n } = this.props;

    if (isLoading) {
      return (
        // TODO: formattedMessage
        <Loader size="large" active className="margin top spacious">
          Ihre Wohnung wird geladen
        </Loader>
      );
    }
    if (isReady) {
      return <div>{children}</div>;
    }
    return (
      <Message
        className="margin top spacious"
        icon="meh"
        header={i18n["buyerPortal.messages.somethingWentWrong"]}
        content={i18n["buyerPortal.messages.missing_configuration"]}
      />
    );
  }
}
